module.exports = "<a ng-click=\"vm.signOut()\" id=\"logout\"><span class=\"link-icon fa fa-sign-out\"></span>{{'Log Out' | translate}}</a>";